import { render, staticRenderFns } from "./SeckillGoodsSelect.vue?vue&type=template&id=7aa8d05a&scoped=true"
import script from "./SeckillGoodsSelect.vue?vue&type=script&lang=js"
export * from "./SeckillGoodsSelect.vue?vue&type=script&lang=js"
import style0 from "./SeckillGoodsSelect.vue?vue&type=style&index=0&id=7aa8d05a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa8d05a",
  null
  
)

export default component.exports